<template>
    <div id="head-drop-list">
        <!--        <div>我是标题按钮</div>-->
        <drop-list :i-class="iClass" :title="title" :menu-list="headList" :type="type"></drop-list>
    </div>
</template>

<script>
    import DropList from "./DropList";
    export default {
        name: "HeadDropList",
        components: {
            DropList
        },
        data(){
            return{
                iClass: "w-e-icon-header",
                title:"设置标题",
                type:'[list]',
                headList:[{elem: '<h1>H1</h1>', value: 'h1' }, { elem: '<h2>H2</h2>', value: 'h2' }, { elem: '<h3>H3</h3>', value: 'h3' }, { elem: '<h4>H4</h4>', value: 'h4' }, { elem: '<h5>H5</h5>', value: 'h5' },{ elem: '<p>正文</p>', value: 'del' }]
            }
        },
        mounted() {
            // alert(this.currentType)
        }

    }
</script>

<style scoped>

</style>